<template>
  <div class="version-container">{{ version }}</div>
</template>

<script>
/**
 * @class Version
 *
 * @description show semantic or user defined version
 * SHOW_VERSION=true
 *
 * user defined version:
 * VERSION=1.2.3.4
 */
export default {
  name: 'Version',
  computed: {
    version() {
      return window.CORE.version ? `${this.$i18n.t('system_version')}: ${window.CORE.version}` : ''
    },
  },
}
</script>

<style lang="scss" scoped>
.version-container {
  line-height: 3;
  font-size: 0.9em;
  opacity: 0.8;
  color: $icon-large;
}
</style>
